import { SignalRProvider } from 'brokertslib/src/context/SignalRProvider'
import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router'

import { SendCalculationModal, SendCalculationVehicleContextProvider } from '@/containers/SendCalculationModal'
import CarkulkaExtraOffersProvider from '@/context/CarkulkaExtraOffersProvider'
import CarkulkaOffersProvider from '@/context/CarkulkaOffersProvider'
import { SortBy } from '@/context/OffersProvider'

import { Container } from '../../../components/Container'
import { Loading } from '../../../components/Loading'
import { Section } from '../../../components/Section'
import { Steps } from '../../../components/Steps'
import WizardForbiddenMessage from '../../../components/WizardForbiddenMessage'
import { InsuranceInfo } from '../../../containers/InsuranceInfo/InsuranceInfo'
import { OffersCar } from '../../../containers/offers/OffersCar'
import { StepsContent } from '../../../context/StepsContext'
import { useInsuranceParamsContext } from '../../../layouts/Wizard'

const baseUrl = import.meta.env.VITE_BASE_URL
const hubUrl = import.meta.env.VITE_CALCULATION_HUB
const url = `${baseUrl}/${hubUrl}`

export const Step3 = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { insuranceParams, insuranceParamsId: paramsId, isLoadingData } = useInsuranceParamsContext()

  if (!isLoadingData && insuranceParams && (insuranceParams.generalParams?.lastWizardStep ?? 1) < 2) {
    navigate('/carkulka/wizard/too-far', { replace: true })
  }

  // pri prichodu z K2 pres "Ulozit a spocitat nabidky" se nabidky vzdy prepocitaji,
  // aby poradce videl aktualni sazby pojistoven. Stav se konzumuje jen jednou (kvuli refreshi stranky).
  const [forceCalculation] = useState<boolean>(!!(location.state as { forceCalculation?: boolean } | null)?.forceCalculation)

  useEffect(() => {
    if (forceCalculation)
      navigate(location.pathname, { replace: true, state: null })
  }, [])

  const [order, setOrder] = useState(1)
  const setOrderFunc = (order: SortBy) => {
    switch (order) {
      case SortBy.Insurer:
        setOrder(3)
        break

      case SortBy.VariantInsurer:
        setOrder(2)
        break

      case SortBy.VariantPrice:
        setOrder(5)
        break

      default:
        setOrder(1)
        break
    }
  }

  const isContract = !!insuranceParams?.generalParams.contractNumber

  return (
    <Section>
      <Container>
        {isLoadingData && <Loading large={true} />}

        {(!paramsId || insuranceParams) &&
          <StepsContent step={3}>
            <SignalRProvider url={url}>
              <Steps icon="car" />

              {paramsId && (
                <CarkulkaOffersProvider insuranceParamsId={paramsId} isContract={isContract} forceCalculation={forceCalculation}>
                  <CarkulkaExtraOffersProvider insuranceParamsId={paramsId} isContract={isContract} forceCalculation={forceCalculation}>
                    <SendCalculationVehicleContextProvider order={order}>

                      <SendCalculationModal />

                      <InsuranceInfo />

                      <OffersCar setOrderFunc={setOrderFunc} />
                      
                    </SendCalculationVehicleContextProvider>
                  </CarkulkaExtraOffersProvider>
                </CarkulkaOffersProvider>
              )}
            </SignalRProvider>
          </StepsContent>
        }

        <WizardForbiddenMessage />
      </Container>
    </Section>
  )
}
